/**
 * 获取1小时降雨
 */
export function getRiskListOption (option) {
  return {
    grid: {
      left: 30,
      right: 30,
      top: 30,
      bottom: 30
    },
    tooltip: {
      trigger: 'axis'
    },
    xAxis: {
      type: 'category',
      axisTick: {
        show: false
      },
      axisLabel: {
        color: '#FFF',
        fontSize: '0.9rem'
      },
      data: option.x
    },
    yAxis: {
      type: 'value',
      name: '（mm）',
      nameTextStyle: {
        fontSize: '0.9rem',
        align: 'right',
        color: '#FFF'
      },
      splitLine: {
        show: false
      },
      axisLabel: {
        fontSize: '0.9rem',
        color: '#FFF'
      },
      max: Math.floor(Math.max(...option.y) + 2),
      min: Math.floor(Math.min(...option.y) + 2)
    },
    series: [
      {
        name: '雨量',
        data: option.y,
        type: 'bar',
        barWidth: option.x.length > 6 ? 15 : 20,
        backgroundStyle: {
          color: 'rgba(180, 180, 180, 0.2)'
        },
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 1,
            x2: 0,
            y2: 0,
            colorStops: [
              {
                offset: 0,
                color: '#2D74F5'
              },
              {
                offset: 1,
                color: '#53A4FA'
              }
            ],
            global: false
          },
          borderRadius: [10, 10, 0, 0]
        }
      }
    ]
  }
}
